import { Entypo } from '@native-base/icons';
import { Center, HStack, Icon, Pressable } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';

function HistoryOptions({ onDelete }) {
  return (
    <HStack
      bg="gray.100"
      height="60"
      alignItems="center"
      justifyContent="flex-end"
    >
      <Pressable onPress={onDelete}>
        <Center width="60" height="60" bg="red.500">
          <Icon as={Entypo} name="trash" color="white" size="sm" />
        </Center>
      </Pressable>
    </HStack>
  );
}

HistoryOptions.propTypes = {
  onDelete: PropTypes.func.isRequired,
};

export default HistoryOptions;
